export default {
  ratePlanType: {
    STANDARD: 'スタンダード',
    BAR: 'ベストアベイラブルレート',
    CORPORATE: 'コーポレート',
    MEMBER: 'メンバー',
    PACKAGE: 'パッケージ',
    PROMOTIONAL: 'プロモーション',
    OTA: 'OTA',
    WHOLESALE: 'ホールセール',
    NEGOTIATED: '交渉レート',
    MIXED: 'ミックス料金',
  },
} as const;
